import {Utilities} from '@shared/utilities/utilities.model';
import {PartsType} from '../../authority-shared/models/enums.model';

export class QuotationModel {
	static CAR_BODY: string = 'CARBODY';
	static MECHANICS: string = 'MECHANIC';
	static PRIORITY_HIGH: number = 1;
	static PRIORITY_URGENT: number = 2;

/** "NEW" | "IN_PROGESS" | "CLOSED"**/
	static ORDER_STATUS_NEW: string = 'NEW';
	static ORDER_STATUS_IN_PROGESS: string= 'IN_PROGESS';
	static ORDER_STATUS_CLOSED: string = 'CLOSED';
	static ORDER_STATUS_CANCELED: string = 'CANCELED';

	/**NEW (DA PROCESSARE) | PROCESSED(PROCESSATO) | EXCLUDED(ESCLUSO) | WRONG(ERRATO) | AUTO_PROVISIONED(AUTOAPPROVVIGIONATO);**/
	static PARTS_STATUS_NEW: string = 'NEW';
	static PARTS_STATUS_PROCESSED: string= 'PROCESSED';
	static PARTS_STATUS_EXCLUDED: string = 'EXCLUDED';
	static PARTS_STATUS_WRONG: string = 'WRONG';
	static PARTS_STATUS_AUTO_PROVISIONED: string = 'AUTO_PROVISIONED';


	/**list_price => prezzo unitario**/
	/**discount => sconto**/
	/**value =>    importo**/
	/**amount => quantità**/

	id: string;
	orderNumber: number;
	orderNumberPrefix: string;
	quotationId: string;
	dealerId: string;
	priority: number;
	type: string;
	plate: string;
	chassis: string;
	commodityName: string;
	commodityAddress: string;
	commodityAddressNumber: string;
	model: string;
	modelDesc: string;
	brandDesc: string;
	engineCode: string;
	status: string;
	createdAt: string;
	entryStatus: string;
	canBeShipped: boolean;
	canBeManaged: boolean;
	part_can_be_removed: boolean;
	partsOrderNumber: string;
	partsOrderNumberPrefix: string;
	parts: Parts[];
	commodityId: string;
	flowType: string;
	rejection_note: string;
	archived: boolean;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.id = model.id;
			this.orderNumber = model.order_number;
			this.quotationId = model.quotation_id;
			this.dealerId = model.dealer_id;
			this.priority = model.priority;
			this.type = model.type;
			this.plate = model.plate;
			this.chassis = model.chassis;
			this.engineCode = model.engine_code;
			this.brandDesc = model.brand_label;
			this.commodityName = model.commodity_name;
			this.commodityAddress = model.commodity_address;
			this.commodityAddressNumber = model.commodity_address_number;
			this.model = model.model;
			this.modelDesc = model.model_label;
			this.status = model.status;
			this.createdAt = model.created_at;
			this.parts = model.parts;
			this.entryStatus = model.entry_status;
			this.canBeShipped = model.actions ? model.actions.can_be_shipped : model.can_be_shipped;
			this.canBeManaged = model.actions ? model.actions.can_be_managed : model.can_be_managed;
			this.part_can_be_removed = model.actions ? model.actions.part_can_be_removed : model.part_can_be_removed;
			this.partsOrderNumber = model.order_number;
			this.partsOrderNumberPrefix = model.order_number_prefix;
			this.orderNumberPrefix = model.order_number_prefix;
			this.commodityId = model.commodity_id;
			this.flowType = model. flow_type;
			this.rejection_note = model.rejection_note;
			this.archived = model.archived;
		}
	}

	setArchived(archived: boolean): void {
		this.archived = archived;
	}

	/**
	 * Indica se l'intervento è chiuso-archiviato
	 * Le pratiche associate all'intervento archiviato non possono essere canalizzate
	 * 
	 * @returns {boolean}
	 */
	isArchived(): boolean {
		// return true;
		return !!this.archived;
	}
}

export interface Parts {
	id: string;
	part_id: string;
	id_par: string;
	oe: string;
	description: string;
	side: string;
	status: string;
	list_price: number;
	discount: number;
	value: number;
	amount: number;
	brand: string;
	brand_label: string;
	aftermarket: boolean;
	elements: Parts[];
	entryStatus: string;
	shipping_date: string;
	// canBeShipped: boolean;
	can_be_shipped: boolean;
	is_arrived_or_not_available: boolean;
	parts_order_number: string;
	parts_order_number_prefix: string;
	frequency_handling: string;
	parent_id?: string;
	type?: PartsType;
}
